// extracted by mini-css-extract-plugin
export default {"container":"EmptyWarning_container__E0sgl","likeAnimation":"EmptyWarning_likeAnimation__8S+bc"};